document.addEventListener('DOMContentLoaded', function () {

  /* ── CUSTOM CURSOR ── */
  (function () {
    var cursor = document.getElementById('oh-cursor');
    var ring   = document.getElementById('oh-cursor-ring');
    if (!cursor || !ring) return;

    cursor.style.pointerEvents = 'none';
    ring.style.pointerEvents   = 'none';

    var mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = (mx - 6) + 'px';
      cursor.style.top  = (my - 6) + 'px';
    });

    document.addEventListener('mouseover', function (e) {
      var el = e.target.closest('button, a, .oh-product-card, .oh-mc-card, .oh-mdot, .oh-thumb, .oh-upsell-card');
      if (el) {
        cursor.style.transform  = 'scale(2)';
        cursor.style.background = '#FF2D55';
      } else {
        cursor.style.transform  = 'scale(1)';
        cursor.style.background = '#FF5C00';
      }
    });

    (function animateRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = (rx - 18) + 'px';
      ring.style.top  = (ry - 18) + 'px';
      requestAnimationFrame(animateRing);
    })();
  })();

  /* ── SCROLL REVEAL ── */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function (r) { revealObs.observe(r); });

  /* ── TOAST NOTIFICATION ── */
  window.showNotif = function (icon, html, borderColor) {
    var n = document.getElementById('oh-notif');
    if (!n) return;
    n.querySelector('.oh-notif-icon').textContent = icon;
    n.querySelector('.oh-notif-text').innerHTML   = html;
    if (borderColor) n.style.borderColor = borderColor;
    n.classList.add('show');
    setTimeout(function () { n.classList.remove('show'); }, 3500);
  };

  /* ── QUICK ADD TO CART ── */
  function attachQuickAdd() {
    document.querySelectorAll('.oh-quick-add').forEach(function (btn) {
      if (btn.dataset.qaAttached) return;
      btn.dataset.qaAttached = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalText = btn.textContent.trim();
        btn.textContent  = 'ADDING...';
        btn.disabled     = true;

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description);
          btn.textContent       = '✓ ADDED';
          btn.style.background  = '#22c55e';
          btn.style.borderColor = '#22c55e';
          showNotif('🛒', '<strong>Added to bag!</strong> ' + (data.product_title || ''), '#FF5C00');
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('.oh-cart-count');
          if (countEl) countEl.textContent = '(' + cart.item_count + ')';
          setTimeout(function () {
            btn.textContent       = originalText;
            btn.style.background  = '';
            btn.style.borderColor = '';
            btn.disabled          = false;
          }, 2000);
        })
        .catch(function (err) {
          btn.textContent      = 'ERROR';
          btn.style.background = '#FF2D55';
          showNotif('!', '<strong>Could not add.</strong> ' + (err.message || ''), '#FF2D55');
          setTimeout(function () {
            btn.textContent      = originalText;
            btn.style.background = '';
            btn.disabled         = false;
          }, 2000);
        });
      }, true);
    });
  }

  attachQuickAdd();
  setTimeout(attachQuickAdd, 1000);

  /* ── SIZE SELECTOR — updates Quick Add variant ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.oh-size-btn');
    if (!btn || btn.classList.contains('soldout')) return;
    var card     = btn.closest('.oh-product-card');
    var quickAdd = card && card.querySelector('.oh-quick-add');
    if (quickAdd) quickAdd.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
    var group = btn.closest('.oh-size-grid, .oh-size-row');
    if (group) group.querySelectorAll('.oh-sz, .oh-size-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });

  /* ── MASCOT SWITCHER ── */
  var EMOJIS = ['🐉', '⚡', '🌙', '🔥'];
  window.switchMascot = function (i, el) {
    document.querySelectorAll('.oh-mdot').forEach(function (d) { d.classList.remove('active'); });
    el.classList.add('active');
    var frame = document.getElementById('oh-hero-mascot');
    if (!frame) return;
    frame.style.opacity    = '0';
    frame.style.transition = 'opacity 0.2s';
    setTimeout(function () {
      var imgUrl = el.dataset.img;
      var name   = el.dataset.name;
      var role   = el.dataset.role;
      frame.innerHTML = imgUrl
        ? '<img src="' + imgUrl + '" style="width:100%;height:100%;object-fit:contain;" alt="' + name + '">'
        : '<span style="font-size:140px;filter:drop-shadow(0 0 40px rgba(255,92,0,0.4))">' + EMOJIS[i] + '</span>';
      var nm = document.getElementById('oh-mascot-name');
      var rl = document.getElementById('oh-mascot-role');
      if (nm) nm.textContent = name;
      if (rl) rl.textContent = role;
      frame.style.opacity = '1';
    }, 200);
  };

  /* ── GALLERY THUMBS ── */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.oh-thumb');
    if (!thumb) return;
    document.querySelectorAll('.oh-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ── MOBILE NAV TOGGLE ── */
  var navToggle = document.getElementById('oh-nav-toggle');
  var mobileNav = document.getElementById('oh-mobile-nav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () { mobileNav.classList.toggle('open'); });
  }

  /* ── HIDE SHOPIFY DEFAULT CARD INFO ── */
  var CARD_SELECTORS = [
    '.oh-product-card .card__information',
    '.oh-product-card .card-information',
    '.oh-product-card .card__content',
    '.oh-product-card .card__badge',
    '.oh-product-card h3',
    '.oh-product-card .price',
    '.oh-product-card .card__footer',
    '.oh-product-card form',
    '.oh-product-card .card__media-spacer',
    '.oh-product-card .full-unstyled-link',
    '.oh-product-card .caption-with-letter-spacing',
    '.oh-product-grid .card__content',
    '.oh-product-grid .card__information',
    '.oh-product-grid .card-information',
    '.oh-product-grid h3',
    '.oh-product-grid .price',
    '.oh-product-grid form',
    '.oh-product-grid .card__badge',
    '.oh-product-grid .card-wrapper',
    '.oh-product-grid .product-card-wrapper'
  ].join(',');

  function hideDefaultCardInfo() {
    document.querySelectorAll(CARD_SELECTORS).forEach(function (el) {
      el.style.setProperty('display',   'none',   'important');
      el.style.setProperty('height',    '0',      'important');
      el.style.setProperty('overflow',  'hidden', 'important');
      el.style.setProperty('padding',   '0',      'important');
      el.style.setProperty('margin',    '0',      'important');
    });
  }

  hideDefaultCardInfo();
  setTimeout(hideDefaultCardInfo, 500);
  new MutationObserver(hideDefaultCardInfo).observe(document.body, { childList: true, subtree: true });

  /* ── PRODUCT IMAGE CLICK TO NAVIGATE ── */
  document.querySelectorAll('.oh-product-img-wrap').forEach(function (wrap) {
    wrap.addEventListener('click', function (e) {
      if (!e.target.closest('.oh-quick-add') && !e.target.closest('.oh-overlay-btn')) {
        var link = wrap.querySelector('.oh-product-img-link');
        if (link) window.location.href = link.href;
      }
    });
  });

});